import { SVGProps } from 'react'

export const TransferIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="currentColor"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M3.30005 18.7496V14.9996C3.30005 13.6829 3.76272 12.5619 4.68805 11.6366C5.61272 10.7119 6.73338 10.2496 8.05005 10.2496H17.85L14 6.39961L15.05 5.34961L20.7001 10.9996L15.05 16.6496L14 15.5996L17.85 11.7496H8.05005C7.15005 11.7496 6.38338 12.0663 5.75005 12.6996C5.11672 13.3329 4.80005 14.0996 4.80005 14.9996V18.7496H3.30005Z"
      fill="currentColor"
    />
  </svg>
)
